// extracted by mini-css-extract-plugin
export var link = "_ty-0";